<app-topnav [llttfPage]="true" [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main" [hidden]="hideForm">
    <div class="facility-heading">Create Invitation</div>
    <div class="designatedFacilityForm" >
      <app-llttf-invitation-form [isSubmitted]="isSubmitted" [llttfinvitation]="llttfinvitation"></app-llttf-invitation-form>
      <div class="form-buttons">
        <input type="submit" class="submit-form-button" (click)="onSubmit()" value="Submit"/>
        <a routerLink="/llttf-invite-list" class="submit-form-button cancel-button">Cancel</a>
      </div>
    </div>
  </div>

  <!-- div to show invite link -->
  <div class="h-30"></div>
  <div [hidden]="!hideForm" class="content">
    <span class="success-span">
      <img src="/assets/smalltick.svg" >&nbsp;<span [innerHTML]="topmsg" ></span>
    </span>
    <div class="h-30"></div>

    <p>Invite Link: {{invitationLink}}</p>
    <div class="h-30"></div>
    <div class="form-buttons">
      <a routerLink="/llttf-invite-list" class="submit-form-button">Return to Invitations</a>
    </div>
  </div>

</div>
<app-footer [bbapp]="true"></app-footer>
